module.exports = __webpack_public_path__ + "static/media/brilliwhite-1.ee7dcfad.jpg";